module.exports = __webpack_public_path__ + "assets/img/LTC040.978dbafe.png";